import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import PageFooter from '@components/UI/PageFooter';
import { makeStyles } from 'tss-react/mui';
import { useLocalAppContext } from '@context/LocalAppContext';
import CoreButton from '@components/Buttons/CoreButton';
const useStyles = makeStyles()((theme) => ({
    landing: {
        backgroundColor: '#fff',
    },
    bodyText: {
        fontFamily: theme.typography.fontFamily,
        fontSize: 16,
        color: theme.palette.grey[500],
        fontWeight: 600,
        lineHeight: 1.45,
    },
    pageContainer: {
        width: '100%',
        position: 'relative',
        backgroundColor: '#F6F6F6',
        paddingTop: '80px',
        [theme.breakpoints.down('header')]: {
            paddingTop: '40px',
        },
    },
    winddownWrapper: {
        maxWidth: '1420px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        margin: '0 auto',
        [theme.breakpoints.down('header')]: {
            padding: '0px 20px 60px',
            flexDirection: 'column',
            alignItems: 'center',
            '& h2': {
                textAlign: 'center',
            },
            '& img': {
                maxWidth: '335px',
            },
        },
    },
    windDown: {
        maxWidth: '650px',
        display: 'flex',
        gap: '40px',
        flexDirection: 'column',
        [theme.breakpoints.down('header')]: {
            alignItems: 'center',
        },
        '& h2': {
            fontSize: '55px',
            fontWeight: 700,
            color: '#25282B',
            margin: 0,
            [theme.breakpoints.down('header')]: {
                fontSize: '30px',
                textAlign: 'center',
            },
        },
        '& p': {
            color: '#73787D',
            fontWeight: 600,
            fontSize: '16px',
            marginBottom: '24px',
            [theme.breakpoints.down('header')]: {
                textAlign: 'center',
            },
        },
    },
    button: {
        width: '209px',
        padding: '16px 80px',
    },
}));
const WithdrawalOnlySiteLandingPage = () => {
    const { classes, cx } = useStyles();
    const queryParams = new URLSearchParams(window.location.search);
    const shouldPromptSignIn = queryParams.has('signIn');
    const { openModal } = useLocalAppContext();
    const handleLoginClick = () => {
        openModal({ type: 'login' });
    };
    useEffect(() => {
        if (shouldPromptSignIn) {
            openModal({ type: 'login' });
        }
    }, [shouldPromptSignIn]);
    return (_jsxs("div", { className: cx(classes.bodyText, classes.landing), children: [_jsx("div", { className: classes.pageContainer, children: _jsxs("section", { className: classes.winddownWrapper, children: [_jsx("img", { src: "/img/landing/home_page_callout_white.png", alt: "Leona from league of legends" }), _jsxs("div", { className: classes.windDown, children: [_jsx("h2", { children: "Repeat is closing down." }), _jsxs("div", { children: [_jsxs("p", { children: ["Repeat is closing down. All tournaments will wind down by June. Learn more by reading the blog", ' ', _jsx("a", { href: "https://www.repeat.gg/content/repeat-closing", target: "_blank", rel: "noopener noreferrer", children: "here" }), "."] }), _jsx("p", { children: "The Repeat mobile app will be delisted and no longer usable at a later date. Thanks for the 10 years of tournaments." }), _jsxs("p", { children: ["Repeat", _jsx("br", {}), "gg"] })] }), _jsx(CoreButton, { onClick: handleLoginClick, size: "lg", className: classes.button, children: _jsx("span", { children: "Log In" }) })] })] }) }), _jsx(PageFooter, {})] }));
};
export default WithdrawalOnlySiteLandingPage;
